import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import { contactServices, serviceCards } from '../../content/siteContent';

function Services() {
  return (
    <main>
      <Seo
        title="Admission Services | Vedanskrix College Admission"
        description="Explore Vedanskrix college admission services including shortlisting, applications, SOP support, visa guidance, and pre-departure assistance."
        keywords={['college admission services', 'student counselling services', 'application support', 'visa guidance Ahmedabad']}
      />

      <section className="ca-page-hero">
        <div className="ca-container">
          <span className="ca-eyebrow">Admission Services</span>
          <h1>Structured support for every important admission step.</h1>
          <p>
            Whether you are still comparing destinations or already preparing documents, our team
            helps organise the next move with practical, student-focused guidance.
          </p>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-card-grid">
          {serviceCards.map((service) => (
            <article key={service.title} className="ca-info-card ca-info-card--large">
              <h2>{service.title}</h2>
              <p>{service.summary}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="ca-section ca-section--soft">
        <div className="ca-container ca-checklist">
          <div>
            <span className="ca-eyebrow">What We Cover</span>
            <h2>Designed to reduce confusion and improve readiness.</h2>
          </div>
          <div className="ca-checklist__grid">
            {contactServices.map((item) => (
              <div key={item} className="ca-checklist__item">
                <span>01</span>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-cta ca-cta--split">
          <div>
            <h2>Need help deciding which service is right for you?</h2>
            <p>Share your academic profile and current stage, and we will guide you on the best next step.</p>
          </div>
          <Link to="/contact" className="ca-button">
            Request Counselling
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Services;
